import React, { FC } from 'react';
import { ImagePopupProps } from '@/pages/CareersPage/CareersPage.types';
import CareersPopup from '@/pages/CareersPage/components/popups/CareersPopup/CareersPopup';
import key from 'weak-key';
import styles from './ImagePopup.module.scss';

const ImagePopup: FC<ImagePopupProps> = ({
  title, backgroundImage, leftImage, rightImages, popupKey,
}) => {
  const renderColumn = (images: string[] | null) => {
    if (!images) {
      return null;
    }

    return (
      <div className={styles.column}>
        {images.map((image) => !!image && (
          <div key={key({ image })}>
            <img alt="" className={styles.image} src={image} />
          </div>
        ))}
      </div>
    );
  };

  return (
    <CareersPopup backgroundImage={backgroundImage} popupKey={popupKey} title={title}>
      <div className={styles.imagesContainer}>
        {!!leftImage && <img alt="" className={styles.leftImage} src={leftImage} />}
        {renderColumn(rightImages)}
      </div>
    </CareersPopup>
  );
};
ImagePopup.displayName = 'ImagePopup';

export default ImagePopup;
